export const SET_CONVERSATION="app/conversationSelected/SET_CONVERSATION"
export const ADD_LOCAL_MESSAGE="app/conversationSelected/ADD_LOCAL_MESSAGE"
